import React from 'react'
import styled from 'styled-components'

type HEXColorProps = {
  color: string
  label: string
} & React.ComponentPropsWithoutRef<typeof Wrapper>

const HEXColorComponent = ({ color, label }: HEXColorProps) => (
  <Wrapper>
    {label}
    <ColorSquare color={color}/>
  </Wrapper>
)

export default (props: HEXColorProps) => (<HEXColorComponent {...props} />)

const Wrapper = styled.span``

const ColorSquare = styled.span<{color: string}>`
    background-color: ${props => props.color};
    width: 15px;
    display: inline-block;
    height: 15px;
    border-radius: 4px;
    vertical-align: middle;
    margin-left: 5px;
    margin-bottom: 1px;
`